/** @module components/tabbed-container */
import baustein from "baustein";
import templateTabbedContainer from "web/script/templates/components/tabbed-container.html";
import analytics from "web/script/analytics/analytics";
import factory from "web/script/dom/factory";

const TAB_SWITCHER_ACTIVE_CLASS = "tab-switcher__tab--active";
const TAB_PAGE_INACTIVE_CLASS = "tab-page--inactive";

/**
 * @constructor
 * @alias module:components/tabbed-container
 * @extends module:baustein
 */
export default baustein.register(
    "tabbed-container",
    /** @lends module:components/tabbed-container.prototype */
    {
        setupEvents(add) {
            add("click", ".tab-switcher__tab", this._onTabClicked);
        },

        _pages: null,

        _tabSwitcher: null,

        init() {
            this._pages = Array.from(this.el.querySelectorAll("[data-tab-page]"));
        },

        switchTab(tabIndex) {
            this._pages.forEach((el, i) => {
                el.classList.toggle(TAB_PAGE_INACTIVE_CLASS, i !== tabIndex);
            });

            Array.from(this._tabSwitcher.querySelectorAll("li")).forEach((li, i) => {
                li.classList.toggle(TAB_SWITCHER_ACTIVE_CLASS, i === tabIndex);
            });
        },

        changeTabName(tabIndex, newText) {
            const tab = Array.from(this._tabSwitcher.querySelectorAll("li"))[tabIndex];
            if (tab) {
                tab.textContent = newText;
            }
        },

        onInsert() {
            var pages = Array.from(this.el.querySelectorAll("[data-tab-page]"));

            var defaultPage = parseInt(this.options.defaultPage, 10) || 0;

            var tabDetails = pages.map(function(thisTab, index) {
                var tabTitle = thisTab.querySelector("[data-tab-title]");
                if (tabTitle) {
                    tabTitle.parentElement.removeChild(tabTitle);
                }

                var tabClasses = thisTab.getAttribute("data-class");

                return {
                    isDefault: index === defaultPage,
                    index: index,
                    title: tabTitle ? tabTitle.textContent : "",
                    classes: tabClasses ? tabClasses.split(" ") : [],
                };
            });

            var classes = this.el.getAttribute("data-class");

            var tabSwitcherData = {
                classes: classes ? classes.split(" ") : [],
                tabs: tabDetails,
            };

            var tabSwitcher = factory.fromString(templateTabbedContainer(tabSwitcherData));

            this.el.insertBefore(tabSwitcher, this.el.firstElementChild);

            this._tabSwitcher = tabSwitcher;

            // if the default tab is lazy loaded, we would want to fetch and render it now.
            var activePage = this._pages[defaultPage];
            this._fetchAndRenderLazyLoadedSection(activePage);

            this.switchTab(defaultPage);
        },

        _onTabClicked(event, tab) {
            if (tab.classList.contains(TAB_SWITCHER_ACTIVE_CLASS)) {
                // no need to do anything
                return;
            }

            var tabIndex = parseInt(
                tab.getAttribute("tab-index") || tab.getAttribute("data-tab-index"),
                10
            );
            var activePage = this._pages[tabIndex];

            this._fetchAndRenderLazyLoadedSection(activePage);
            this.switchTab(tabIndex);

            // Analytics
            if (activePage) {
                var tabEventLabel =
                    activePage.getAttribute("tab-event-label") ||
                    activePage.getAttribute("data-tab-event-label");
                if (tabEventLabel) {
                    analytics.event("NAVIGATION", "TAB_CLICK", tabEventLabel);
                }
            }
        },

        /**
         * Some sections of related products area might be lazy loaded, this method
         * finds the right `related-products-section-loader` component (there might be more than
         * one of these components) to call fetchAndRender
         */
        _fetchAndRenderLazyLoadedSection(activeSection) {
            const tabSection = baustein.fromElement(activeSection);
            if (tabSection && "fetchAndRender" in tabSection) {
                tabSection.fetchAndRender();
            }
        },
    }
);
